import getImageElementsByContentId from './getImageElementsByContentId';
import { lazyOperateContent, EditorViewState } from 'owa-editor';
import { CID_PREFIX } from './constants';
import { trace } from 'owa-trace';

export default async function setOriginalSrcForSmime(
    editorViewState: EditorViewState,
    oldContentId: string,
    newContentId: string
): Promise<boolean> {
    const operateContent = await lazyOperateContent.import();
    let result = false;

    operateContent(editorViewState, editor => {
        const elements = getImageElementsByContentId(editor, oldContentId);

        // If element is found, we set the originalSrc. The src attribute is anyways stripped off
        // when data is sent to server, so we need not set that using lazyLoadFromAttachmentServiceUrl
        if (elements.length > 0) {
            const targetElement = elements[0];
            targetElement.setAttribute('originalSrc', CID_PREFIX + newContentId);
            result = true;
        } else {
            trace.warn(
                'S/MIME onSmimeUploadSuccess : Inline image target element not found for content id : ' +
                    oldContentId
            );
        }
        return null;
    });

    return result;
}
